import React from 'react';
import './styles.css';
import NavBar from './NavBar';

const SafetyTips = () => {
  return (
    <div>
      {NavBar()}
      <div className="safety-page-wrapper">
        <div className="safety-header">
          <h1>Community Safety Guidelines</h1>
          <p>Your safety is our priority. Follow these tips to stay secure while meeting new people on Pool Party Social Club.</p>
        </div>

        <div className="safety-section">
          <h2>🔒 Protect Your Personal Information</h2>
          <p>Never share sensitive details like your full name, home address, workplace, or financial information with people you've just met. Pool Party encourages keeping your conversations inside the app until you're comfortable and have verified the person.</p>
        </div>

        <div className="safety-section">
          <h2>🎥 Use In-App Video Chat First</h2>
          <p>Pool Party's live face-to-face video chat lets you get to know someone in real-time before meeting up in person. This feature helps ensure more authentic connections and lets you verify who you're talking to.</p>
        </div>

        <div className="safety-section">
          <h2>🚩 Watch for Red Flags</h2>
          <ul>
            <li>Requests for money, gift cards, or financial help — especially early on.</li>
            <li>Overly pushy or urgent behavior that seems off.</li>
            <li>Reluctance to video call or meet in public places.</li>
            <li>Stories that seem inconsistent or too good to be true.</li>
          </ul>
          <p>If something feels off, trust your instincts. Report suspicious users directly through the Pool Party app.</p>
        </div>

        <div className="safety-section">
          <h2>📍 Meet in Public and Tell Someone</h2>
          <p>For your first in-person meeting, choose a public location during the day. Let a friend or family member know where you're going and who you're meeting. Share your location when possible and keep your phone charged.</p>
        </div>

        <div className="safety-section">
          <h2>✅ Verify Their Identity</h2>
          <p>Use Pool Party's video chat to confirm the person's appearance. Be cautious of anyone who avoids showing their face or asks to switch to other platforms too quickly.</p>
        </div>

        <div className="safety-section">
          <h2>🛡️ Report and Block Suspicious Users</h2>
          <p>If someone makes you feel uncomfortable, uses abusive language, or breaks our community guidelines, use the in-app tools to block and report them. We take reports seriously and investigate all safety concerns.</p>
        </div>

        <div className="safety-section">
          <h2>📱 Stay Up to Date</h2>
          <p>Ensure you're using the latest version of the Pool Party app to benefit from the newest safety features, bug fixes, and security updates.</p>
        </div>

        <div className="safety-section">
          <h2>❤️ Respect and Consent</h2>
          <p>Everyone deserves a respectful experience. Always be mindful of boundaries during all interactions — both on video and in person. If someone seems uncomfortable, respect their space.</p>
        </div>

        <div className="safety-footer">
          <p>Stay smart. Stay safe. And enjoy making meaningful connections on Pool Party Social Club — where safety, authenticity, and real-time conversation come first.</p>
        </div>
      </div>
    </div>
  );
};

export default SafetyTips;
